import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoinSend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 22,
	viewBox: "0 0 23 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3611 14.6667C19.3611 15.2167 18.8111 15.675 17.8028 16.0417C16.9778 16.3167 15.9695 16.5 14.7778 16.5C13.5861 16.5 12.5778 16.3167 11.7528 16.0417C10.8361 15.675 10.1945 15.2167 10.1945 14.6667C10.1945 13.6583 12.2111 12.8333 14.7778 12.8333C17.3445 12.8333 19.3611 13.6583 19.3611 14.6667Z",
			stroke: "white",
			strokeWidth: 1.35,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.3611 14.6667V17.4167C19.3611 17.9667 18.7195 18.425 17.8028 18.7917C16.9778 19.0667 15.9695 19.25 14.7778 19.25C13.5861 19.25 12.5778 19.0667 11.7528 18.7917C10.8361 18.425 10.1945 17.9667 10.1945 17.4167V14.6667C10.1945 15.2167 10.8361 15.675 11.7528 16.0417C12.5778 16.3167 13.6778 16.5 14.7778 16.5C15.9695 16.5 16.9778 16.3167 17.8028 16.0417C18.8111 15.675 19.3611 15.2167 19.3611 14.6667Z",
			stroke: "white",
			strokeWidth: 1.35,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.44442 11.9167C6.25275 11.9167 5.24442 11.7333 4.41942 11.4583C3.50275 11.0917 2.86108 10.6333 2.86108 10.0833C2.86108 9.075 4.87775 8.25 7.44442 8.25C10.0111 8.25 12.0278 9.075 12.0278 10.0833",
			stroke: "white",
			strokeWidth: 1.35,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.44442 11.9167C6.25275 11.9167 5.24442 11.7333 4.41942 11.4583C3.41108 11.0917 2.86108 10.6333 2.86108 10.0833V12.8333C2.86108 13.3833 3.50275 13.8417 4.41942 14.2083C5.24442 14.4833 6.25275 14.6667 7.44442 14.6667",
			stroke: "white",
			strokeWidth: 1.35,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7777 7.33333L19.361 2.75",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9695 2.75H19.3611V6.14167",
			stroke: "white",
			strokeWidth: 1.35,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCoinSend;
